// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"8e5b5879","496":"92df8767"}[chunkId] + ".chunk.js";
};